var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.667 3.73A3.063 3.063 0 013.731.667h30.536a3.061 3.061 0 013.067 3.063v30.537a3.063 3.063 0 01-3.065 3.066H3.73a3.062 3.062 0 01-3.064-3.065V3.73zm14.514 10.916h4.965v2.494c.716-1.434 2.55-2.724 5.305-2.724 5.281 0 6.533 2.855 6.533 8.094v9.703h-5.345v-8.51c0-2.983-.717-4.666-2.537-4.666-2.525 0-3.575 1.815-3.575 4.666v8.51h-5.346V14.646zM6.014 31.985h5.347V14.416H6.014v17.569zm6.112-23.298a3.439 3.439 0 11-6.876.15 3.439 3.439 0 016.876-.15z",
    fill: "#fff"
  })));
}
export default SvgLinkedinWhite;